const IATA: Record<string, string> = {
  'barcelona': 'BCN', 'tokyo': 'TYO', 'paris': 'PAR', 'lisbon': 'LIS',
  'lisboa': 'LIS', 'amsterdam': 'AMS', 'prague': 'PRG', 'lofoten': 'LOF',
  'madrid': 'MAD', 'london': 'LON', 'rome': 'FCO', 'new york': 'JFK',
  'dubai': 'DXB', 'berlin': 'BER', 'vienna': 'VIE', 'bangkok': 'BKK',
  'sydney': 'SYD', 'los angeles': 'LAX', 'miami': 'MIA', 'chicago': 'ORD',
  'toronto': 'YYZ', 'mexico city': 'MEX', 'buenos aires': 'EZE',
  'istanbul': 'IST', 'seoul': 'ICN', 'beijing': 'PEK', 'shanghai': 'PVG',
  'singapore': 'SIN', 'hong kong': 'HKG', 'mumbai': 'BOM', 'delhi': 'DEL',
};

export function getIataCode(city: string): string {
  return IATA[city.toLowerCase()] ?? city.slice(0, 3).toUpperCase();
}
